export default __webpack_public_path__ + "static/media/privacy_policy.6434af44.md";